import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-multi-select-text',
    templateUrl: './multi-select-text.component.html',
    styleUrls: ['./multi-select-text.component.scss'],
})
export class MultiSelectTextComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
